'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { ErrorServiceUnavailable } from '@/components/common/Error';
const VaultYourPositionChartError = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="w-full" data-testid="vault-v1-your-position-error"><ErrorServiceUnavailable minHeight="395px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(VaultYourPositionChartError);